import {gql} from "@apollo/client";


export const SELECT_PERSON_BY_KEYCLOAK_UUID = gql`
    query getPersonByKeycloakUuid ($keycloak_uuid: uuid!) {
        polon_person(where: {person_accounts: {keycloak_uuid: {_eq: $keycloak_uuid}}}) {
            id
            polon_uid
            first_name
            last_name
            person_studies {
                study_id
            }
            person_accounts {
                email
                keycloak_uuid
            }
    }
}`